<template>
  <div class="index_box border_box">
    <div class="corner"></div>
    <div class="corner"></div>
    <div class="corner"></div>
    <div class="corner"></div>

    <img alt class="index_box_title" src="../../../../ui/LianPoH5/images/index_box_title.png" />
    <div class="index_box_total">
      当前已有<span>超过200万</span>用户秒杀成功
    </div>
    <div class="index_box_lianpo"></div>
    <div @click="clickDirectPay" class="index_box_btn" v-if="showPriceInfo">
      <img alt src="../../../../ui/LianPoH5/images/index_box_btn.jpg" />
      单人秒杀皮肤 60点券
    </div>
    <div @click="openTuanPrompt" class="index_box_btn_2" v-if="showPriceInfo">
      <img src="../../../../ui/LianPoH5/images/index_box_btn_2.png" />
      <div class="text_box">
        <div class="text1">发起礼包拼团 60点券</div>
        <div class="text2">荣耀征程礼包：廉颇·无尽征程+30荣耀积分</div>
      </div>
    </div>
    <div class="index_box_div_text">成团发货，不成团退款</div>
  </div>
</template>

<script>
export default {
  name: "ProductInfo",
  props: ["showPriceInfo", "clickDirectPay", "openTuanPrompt"]
}
</script>
